<template>
  <el-form
    class="auditModel"
    ref="formRef"
    :model="formData"
    :rules="rules"
    size="small"
    label-width="130px"
  >
    <el-form-item
      label="回退后上架版本"
      prop="backVersionCode"
      v-if="detailData.status === 400"
    >
      {{ formData.backVersionCode }}
    </el-form-item>
    <el-form-item
      label="回退原因"
      prop="backReason"
      v-if="detailData.status === 400"
    >
      {{ formData.backReason }}
    </el-form-item>
    <el-form-item
      label="下架原因"
      prop="reasonForRemoval"
      v-if="detailData.status === 500"
    >
      {{ formData.reasonForRemoval }}
    </el-form-item>
    <el-form-item label="备注" prop="remarks" v-if="detailData.status === 500">
      {{ formData.remarks }}
    </el-form-item>
    <el-form-item label="审核结果" prop="reviewResult">
      <el-radio-group v-model="formData.reviewResult">
        <el-radio :label="1">通过</el-radio>
        <el-radio :label="2">不通过</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="审核意见"
      prop="reviewComment"
      :rules="[
        { required: formData.reviewResult == 2, message: '请输入审核意见' },
      ]"
    >
      <el-input
        type="textarea"
        :autosize="{ minRows: 6, maxRows: 6 }"
        show-word-limit
        maxlength="100"
        v-model="formData.reviewComment"
        suffix-icon="el-icon-date"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item label="文件上传">
      <UploadFile
        type="other"
        class="ml10"
        @success="uploadSuccess"
        v-model="formData.accessFilePath"
      ></UploadFile>
      <div class="ml10" v-show="formData.fileName">
        <span>{{ formData.fileName }}</span>
        <i class="el-icon-close cursor ml10" @click="handleRemoveFile()"></i>
      </div>
    </el-form-item>
    <div class="disfr jc ac">
      <el-button size="small" type="primary" @click="handleSubmitAudit"
        >提交</el-button
      >
    </div>
  </el-form>
</template>

<script>
import UploadFile from "@/components/UploadFile.vue";
export default {
  components: { UploadFile },
  props: {
    detailData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  created() {
    this.init(this.detailData);
  },
  data() {
    return {
      formData: {
        reviewResult: 1,
        reviewComment: "",
        accessFilePath: "",
        accessFileId: "",
        fileName: "",
      },
      rules: {
        reviewResult: [{ required: true, message: "请选择审核结果" }],
      },
      disabled: false,
    };
  },
  methods: {
    uploadSuccess(file) {
      this.formData.accessFilePath = file.accessPath;
      this.formData.accessFileId = file.fileId;
      this.formData.fileName = file.fileName;
    },
    handleRemoveFile() {
      this.formData.accessFilePath = "";
      this.formData.accessFileId = "";
      this.formData.fileName = "";
    },
    handleSubmitAudit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.formData);
        }
      });
    },
    init(data) {
      this.formData = {
        backVersionCode: data.backVersionCode,
        backReason: data.backReason,
        reasonForRemoval: data.reasonForRemoval,
        remarks: data.remarks,
        reviewResult: 1,
        reviewComment: "",
        accessFilePath: "",
        fileId: "",
        fileName: "",
      };
    },
  },
  watch: {
    detailData(data) {
      this.init(data);
    },
  },
};
</script>

<style lang="scss">
.auditModel {
  width: 50%;
  margin: 0 auto;
  .el-input,
  .el-textarea {
    display: inline-block;
    width: 300px;
  }
  .formItemRemark {
    font-size: 12px;
    // width:700px;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 12px;
    padding-right: 12px;
  }
  .el-date-editor .el-input__prefix {
    left: auto;
    right: 5px;
  }
}
</style>
